import api from '@/services/utils/base';

export default class Timezone {
  getList(payload: any) {
    return api.get('timezones', payload)
      .then((res: any) => {
        return Promise.resolve(res.data.payload);
      })
      .catch((err: any) => {
        return Promise.reject(err);
      });
  }
}
